import axios, { AxiosResponse } from 'axios'

import { RequestQuery } from '@models/apiBase'
import { Response } from '@models/apiBase'
import { WithFilter } from '@models/apiBase'
import { ID } from '@models/base'
import { CashierSessionModel } from '@models/cashierSession'
import { PrinterDataModel } from '@models/printerData'

import { API_URL } from '@/constants/constant'

const CASHIER_SESSIONS_URL = `${API_URL}/cashier-sessions`

type ResponseCashierSessions = Response<WithFilter<Array<CashierSessionModel>>>

type ResponseCashierSession = Response<{
  cashier_session: CashierSessionModel
}>

type ResponseOpenDrawer = Response<{
  printer_data: PrinterDataModel
  signature: string
}>

export type PayloadBeginCashierSession = {
  cashier_id: ID
  clinic_manager_otp: string
  clinic_manager_user_id: ID
  starting_cash: number
}

export type PayloadEndCashierSession = {
  cashier_note?: string
  clinic_manager_note?: string
  cashier_otp: string
}

export type PayloadUpdateMoneyCount = {
  receipt_count?: number
  notes_100000?: number
  notes_75000?: number
  notes_50000?: number
  notes_20000?: number
  notes_10000?: number
  notes_5000?: number
  notes_2000?: number
  notes_1000?: number
  coins_1000?: number
  coins_500?: number
  coins_200?: number
  coins_100?: number
}

export interface ICashierSessionsAPI {
  filter: (query: RequestQuery) => Promise<ResponseCashierSessions>

  get: (id: ID) => Promise<ResponseCashierSession>

  begin: (payload: PayloadBeginCashierSession) => Promise<ResponseCashierSession>

  getActive: () => Promise<ResponseCashierSession>

  end: (id: ID, payload: PayloadEndCashierSession) => Promise<ResponseCashierSession>

  close: () => Promise<ResponseCashierSession>

  updateMoneyCount: (id: ID, payload: PayloadUpdateMoneyCount) => Promise<ResponseCashierSession>

  openDrawer: () => Promise<ResponseOpenDrawer>
}

export const CashierSessionsAPI: ICashierSessionsAPI = {
  filter: async (query) => {
    return axios.post(`${CASHIER_SESSIONS_URL}/filter`, query).then((r: AxiosResponse) => r.data)
  },

  get: async (id) => {
    return axios.get(`${CASHIER_SESSIONS_URL}/${id}`).then((r: AxiosResponse) => r.data)
  },

  begin: async (payload) => {
    return axios.post(CASHIER_SESSIONS_URL, payload).then((r: AxiosResponse) => r.data)
  },

  getActive: async () => {
    return axios.get(`${CASHIER_SESSIONS_URL}/active`).then((r: AxiosResponse) => r.data)
  },

  end: async (id, payload) => {
    return axios.patch(`${CASHIER_SESSIONS_URL}/${id}/end`, payload).then((r: AxiosResponse) => r.data)
  },

  close: async () => {
    return axios.patch(`${CASHIER_SESSIONS_URL}/close`).then((r: AxiosResponse) => r.data)
  },

  updateMoneyCount: async (id, payload) => {
    return axios.patch(`${CASHIER_SESSIONS_URL}/${id}/money-count`, payload).then((r: AxiosResponse) => r.data)
  },

  openDrawer: async () => {
    return axios.post(`${CASHIER_SESSIONS_URL}/open-drawer`).then((r: AxiosResponse) => r.data)
  },
}
